import styled from "styled-components"
import { Link } from "gatsby"

export const LogoWrapper = styled(Link)``
